namespace TabAurous.Master {
    export interface SalesPersonRow {
        EmployeeId?: number;
        DesignationId?: number;
        EmployeeName?: string;
        EmployeeCode?: string;
        EmploymentType?: string;
        DepartmentId?: number;
        ManagerId?: number;
        ReportToId?: number;
        Dob?: string;
        MaritalStatus?: string;
        Gender?: string;
        Qualification?: string;
        Address?: string;
        PhoneNumber?: string;
        MobileNumber?: string;
        Email?: string;
        JoiningDate?: string;
        TerminationDate?: string;
        IsDisabled?: boolean;
        Narration?: string;
        BloodGroup?: string;
        PassportNo?: string;
        PassportExpiryDate?: string;
        LabourCardNumber?: string;
        LabourCardExpiryDate?: string;
        VisaNumber?: string;
        VisaExpiryDate?: string;
        SalaryType?: string;
        DailyWage?: number;
        BankName?: string;
        BranchName?: string;
        BankAccountNumber?: string;
        BranchCode?: string;
        BankIfsc?: string;
        PanNumber?: string;
        PfNumber?: string;
        EsiNumber?: string;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        DefaultPackageId?: number;
        CompanyId?: number;
        Details?: OMS.TargetMasterRow[];
    }

    export namespace SalesPersonRow {
        export const idProperty = 'EmployeeId';
        export const nameProperty = 'EmployeeName';
        export const localTextPrefix = 'Master.SalesPerson';
        export const deletePermission = 'HR:SalesPerson:Delete';
        export const insertPermission = 'HR:SalesPerson:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:SalesPerson:Edit';

        export declare const enum Fields {
            EmployeeId = "EmployeeId",
            DesignationId = "DesignationId",
            EmployeeName = "EmployeeName",
            EmployeeCode = "EmployeeCode",
            EmploymentType = "EmploymentType",
            DepartmentId = "DepartmentId",
            ManagerId = "ManagerId",
            ReportToId = "ReportToId",
            Dob = "Dob",
            MaritalStatus = "MaritalStatus",
            Gender = "Gender",
            Qualification = "Qualification",
            Address = "Address",
            PhoneNumber = "PhoneNumber",
            MobileNumber = "MobileNumber",
            Email = "Email",
            JoiningDate = "JoiningDate",
            TerminationDate = "TerminationDate",
            IsDisabled = "IsDisabled",
            Narration = "Narration",
            BloodGroup = "BloodGroup",
            PassportNo = "PassportNo",
            PassportExpiryDate = "PassportExpiryDate",
            LabourCardNumber = "LabourCardNumber",
            LabourCardExpiryDate = "LabourCardExpiryDate",
            VisaNumber = "VisaNumber",
            VisaExpiryDate = "VisaExpiryDate",
            SalaryType = "SalaryType",
            DailyWage = "DailyWage",
            BankName = "BankName",
            BranchName = "BranchName",
            BankAccountNumber = "BankAccountNumber",
            BranchCode = "BranchCode",
            BankIfsc = "BankIfsc",
            PanNumber = "PanNumber",
            PfNumber = "PfNumber",
            EsiNumber = "EsiNumber",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            DefaultPackageId = "DefaultPackageId",
            CompanyId = "CompanyId",
            Details = "Details"
        }
    }
}
